import signInProgress from '../../../../Scripts/signInProgress.js';

window.addEventListener("load", function () {
    const signInLinks = document.querySelectorAll('.sign-in-reminder__btn');
    signInLinks.forEach(link => {
        const baseUrl = link.getAttribute('data-login-base-url');
        const currentUrl = encodeURIComponent(window.location.href);
        link.href = baseUrl + '?returnUrl=' + currentUrl;

        // Slim progress bar feedback through the SSO redirect that follows the click.
        link.addEventListener('click', function () {
            signInProgress.start();
        });
    });

    const signInReminders = document.querySelectorAll('.sign-in-reminder');

    const closeButtons = document.querySelectorAll('.sign-in-reminder__close-icon');
    closeButtons.forEach(closeButton => {
        closeButton.addEventListener('click', function () {
            const signInReminder = this.closest('.sign-in-reminder');
            if (signInReminder) {
                signInReminder.classList.remove("visible");
                setTimeout(() => {
                    signInReminder.style.display = "none";
                }, 1000);

                document.cookie = "signInReminderClosed=true; path=/; max-age=86400"; // 24 hours
            }
        });
    });

    signInReminders.forEach(signInReminder => {
        setTimeout(() => {
            signInReminder.style.display = "block";
            signInReminder.classList.add("visible");
        }, 2000);
        setTimeout(() => {
            signInReminder.classList.remove("visible");
            setTimeout(() => {
                signInReminder.style.display = "none";
            }, 1000);
        }, signInReminderTimeoutDuration);
    });
});